import React, { useEffect, useState } from 'react'
import AddressTypeChangeView from './components/AddressTypeChangeView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const AddressTypeChange = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('address-type-change', 'Change of Address', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [i18n.language])

  return isError ? <Error /> : <AddressTypeChangeView setIsError={setIsError} />
}

export default withTranslation('common')(AddressTypeChange)
